import { useCallback, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

export const useWebSocket = () => {
    const socketRef = useRef(null);
    const connect = useCallback((token) => {
        if (socketRef.current?.connected) return;

        socketRef.current = io(process.env.REACT_APP_BACKEND_WEBSOCKET_URL, {
            withCredentials: true,
            transports: ['websocket'],
            auth: { token },
            autoConnect: false
        });

        console.log("Conectando al socket:", process.env.REACT_APP_BACKEND_WEBSOCKET_URL);

        socketRef.current.connect();

        socketRef.current.on('connect', () => {
            console.log('WebSocket conectado');
        });

        socketRef.current.on('disconnect', () => {
            console.log('WebSocket desconectado');
        });

        socketRef.current.on('connect_error', (err) => {
            console.error('Error de conexión WebSocket:', err.message);
        });
    }, []);

    const disconnect = useCallback(() => {
        if (socketRef.current) {
            socketRef.current.disconnect();
            socketRef.current = null;
        }
    }, []);

    const on = useCallback((event, callback) => {
        if (socketRef.current) {
            socketRef.current.on(event, callback);
        }
    }, []);

    const off = useCallback((event, callback) => {
        if (socketRef.current) {
            socketRef.current.off(event, callback);
        }
    }, []);

    useEffect(() => {
        return () => disconnect();
    }, [disconnect]);

    return {
        socket: socketRef.current,
        connect,
        disconnect,
        on,
        off
    };
};